export const ssRoutes = [
  { key: 'SSSS', route: '/suite-search/search' },
];
